var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiplayerStringIcon = function SvgMultiplayerStringIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "transparent",
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 5.501,
    transform: "translate(.047 49.224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 52.491,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 2.984,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.215,
    height: 27.215,
    x: 101.998,
    y: 52.527,
    strokeLinecap: "square",
    rx: 6.876,
    ry: 6.876,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    stroke: "currentColor",
    d: "M30.262 66.134h22.435"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    stroke: "currentColor",
    d: "M79.769 66.134h22.435"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0.184,
    d: "M24.89 37.214c6.501 0 11.787-5.285 11.787-11.787 0-6.502-5.286-11.787-11.787-11.787-6.502 0-11.788 5.285-11.788 11.787 0 6.502 5.286 11.787 11.788 11.787zm82.512 0c6.501 0 11.787-5.285 11.787-11.787 0-6.502-5.286-11.787-11.787-11.787-6.502 0-11.788 5.285-11.788 11.787 0 6.502 5.286 11.787 11.788 11.787zm5.894 5.894h-11.788c-3.241 0-6.17 1.308-8.306 3.426 7.422 4.07 12.69 11.419 13.832 20.15h12.155a5.887 5.887 0 005.894-5.895v-5.893c0-6.502-5.286-11.788-11.787-11.788zm-47.15 0c11.4 0 20.628-9.227 20.628-20.628 0-11.4-9.227-20.628-20.628-20.628-11.4 0-20.628 9.227-20.628 20.628 0 11.4 9.227 20.628 20.628 20.628zm14.145 5.894h-1.529c-3.83 1.842-8.085 2.947-12.616 2.947-4.531 0-8.767-1.105-12.616-2.947H52c-11.713 0-21.217 9.504-21.217 21.217v5.305c0 4.88 3.96 8.84 8.841 8.84h53.044c4.88 0 8.84-3.96 8.84-8.84v-5.305c0-11.713-9.503-21.217-21.217-21.217zM39.09 46.534a11.753 11.753 0 00-8.307-3.426H18.996c-6.502 0-11.787 5.286-11.787 11.788v5.893a5.887 5.887 0 005.893 5.894H25.24c1.16-8.73 6.428-16.079 13.85-20.15z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiplayerStringIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multiplayer-string-icon.b91a9e7eaeefdbffa4b608fa4ab32a2d.svg";